import React from 'react';
import { Anchor, Waves } from "lucide-react";

const Features = () => {
  const features = [
    {
      image: "/assets/images/image1.png",
      title: "Global Networking and Collaboration",
      description: "Ministers, shipping executives, managing directors, policy experts, and academies convene under one roof, offering unrivalled access to high-impact partnerships.",
    },
    {
      image: "/assets/images/image2.png",
      title: "Actionable Insights & Best Practices",
      description: "Get practical takeaways from case studies, success stories, and panel discussions on financing, crew welfare, and technology adoption that can be implemented immediately.",
    },
    {
      image: "/assets/images/image3.png",
      title: "Gain Value from Africa's Maritime Offering",
      description: "Engage with Academies and Manning Sources from Africa providing world class resources, and build your talent pipeline.",
    },
    {
      image: "/assets/images/image4.png",
      title: "Elevated Brand & Thought Leadership",
      description: "Sponsors and speakers showcase their expertise, solutions, and success stories to inspire and guide future pioneers in regards to crewing and manning services.",
    },
  ];

  return (
    <section className="pt-20 relative" style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
     
      <div className="absolute inset-0  z-0"></div>
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-20 left-10 transform rotate-12">
          <Anchor className="h-32 w-32 text-primary-navy" />
        </div>
        <div className="absolute bottom-20 right-10 transform -rotate-12">
          <Waves className="h-24 w-24 text-primary-navy" />
        </div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary-navy mb-4">
            Why This Conference {" "}
            <span className="text-[#A65C4A]">Matters</span>
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-primary-orange to-primary-blue mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Key benefits and opportunities at Africa's premier maritime conference
          </p>
        </div>

        {/* Features Grid */}
        <div className="relative py-12">
         
          <div className=" relative z-10">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-2 ">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white/95 rounded-lg overflow-hidden shadow-lg backdrop-blur-sm border border-white/20 hover:shadow-xl transition-all duration-300"
            >
              {/* Background Image */}
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={feature.image} 
                  alt={feature.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-navy to-transparent"></div>
              </div>

              {/* Content */}
              <div className=" py-6 text-center ">
                <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
                <p className="text-gray-700  text-start px-2">{feature.description}</p>
              </div>
            </div>
          ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;